import {Button} from "antd";
import React, {useEffect, useRef, useState} from "react";
import useUserContext from "../../hooks/useUserContext";
import useAppContext from "../../hooks/useAppContext";
import useToast from "../../hooks/useToast";
import {ToastSkin} from "../../context/ToastContext";
import "./notifications-email.css";
import {BigInput} from "../forms/bigInput/BigInput";
import {updateNotificationsEmail} from "../../api/updateNotificationsEmail";

const NotificationsEmail = () => {
    const [email, setEmail] = useState('');
    const { selectedDomain } = useUserContext();
    const { data: { shop } } = useAppContext();
    const { showToast } = useToast();
    const { actions: { loadShop }} = useAppContext();
    const [isSaving, setIsSaving] = useState(false);
    const [isClearing, setIsClearing] = useState(false);

    useEffect(() => {
        shop.data.notificationsEmail && setEmail(shop.data.notificationsEmail);
    }, [shop]);

    const onSubmitNotificationsEmail = async () => {
        setIsSaving(true);
        const response = selectedDomain && await updateNotificationsEmail(selectedDomain, email);
        setIsSaving(false);
        if(response) {
            loadShop();
            showToast({
                skin: ToastSkin.approval,
                text: 'Your email was successfully saved. Notifications will be sent to this email from now on.'
            });
        }
    }

    const onClearNotificationsEmail = async () => {
        setIsClearing(true);
        const response = selectedDomain && await updateNotificationsEmail(selectedDomain, null);
        setIsClearing(false);
        if(response) {
            loadShop();
            setEmail('');
            showToast({
                skin: ToastSkin.approval,
                text: 'Your email was successfully removed. Notifications will not be sent to you from now on'
            });
        }
    }

    return (
        <div className="sub-section notifications-email">
            <div className="sub-section-title">
                Receive unread chat alerts by email
            </div>
            <div className="sub-section-description">
                Set the email where you’d like to receive notifications about new client conversations and other important updates.
            </div>
            <div className="sub-section-content">
                <BigInput value={email} setValue={setEmail} placeholder="john@doe.com" />
                <div className="buttons">
                    <Button type="primary" size="large" loading={isSaving} disabled={isClearing || !email || email === shop.data.notificationsEmail} onClick={onSubmitNotificationsEmail}>Update Email</Button>
                    <Button type="text" size="large" loading={isClearing} disabled={!shop.data.notificationsEmail} onClick={onClearNotificationsEmail}>Clear Email</Button>
                </div>
            </div>
        </div>
    )
}

export default NotificationsEmail;